var map = {
	"./AIDX Logo.png": "./src/img/AIDX Logo.png",
	"./AIDX Logo_v0.png": "./src/img/AIDX Logo_v0.png",
	"./AIDX_logo_only_name.svg": "./src/img/AIDX_logo_only_name.svg",
	"./Anyswap.png": "./src/img/Anyswap.png",
	"./Anyswap.svg": "./src/img/Anyswap.svg",
	"./Artwork.svg": "./src/img/Artwork.svg",
	"./Artwork_gmx.svg": "./src/img/Artwork_gmx.svg",
	"./Banxa.png": "./src/img/Banxa.png",
	"./DROP_DOWN.svg": "./src/img/DROP_DOWN.svg",
	"./DYM 1.png": "./src/img/DYM 1.png",
	"./Fjord.png": "./src/img/Fjord.png",
	"./Frame.svg": "./src/img/Frame.svg",
	"./Hop.png": "./src/img/Hop.png",
	"./Hop.svg": "./src/img/Hop.svg",
	"./Hop_dark.png": "./src/img/Hop_dark.png",
	"./Hop_dark.svg": "./src/img/Hop_dark.svg",
	"./Leap 2.png": "./src/img/Leap 2.png",
	"./OpenAI_Logo.svg.png": "./src/img/OpenAI_Logo.svg.png",
	"./Reputation_Logo.png": "./src/img/Reputation_Logo.png",
	"./Synapse.png": "./src/img/Synapse.png",
	"./Synapse.svg": "./src/img/Synapse.svg",
	"./adx_gmx.png": "./src/img/adx_gmx.png",
	"./adx_logo.png": "./src/img/adx_logo.png",
	"./adx_logo.svg": "./src/img/adx_logo.svg",
	"./adx_logo_footer.png": "./src/img/adx_logo_footer.png",
	"./adx_logo_link.png": "./src/img/adx_logo_link.png",
	"./adx_logo_small.png": "./src/img/adx_logo_small.png",
	"./adx_slp.png": "./src/img/adx_slp.png",
	"./binance.png": "./src/img/binance.png",
	"./bscscan.png": "./src/img/bscscan.png",
	"./btn_big_arbitrum.png": "./src/img/btn_big_arbitrum.png",
	"./btn_big_avalanche.png": "./src/img/btn_big_avalanche.png",
	"./btn_big_base.png": "./src/img/btn_big_base.png",
	"./btn_big_bsc.png": "./src/img/btn_big_bsc.png",
	"./btn_big_goerli.png": "./src/img/btn_big_goerli.png",
	"./btn_big_purchasegmx.png": "./src/img/btn_big_purchasegmx.png",
	"./btn_big_purchasegmx.svg": "./src/img/btn_big_purchasegmx.svg",
	"./buy_gmx.svg": "./src/img/buy_gmx.svg",
	"./buy_gmx_bond.svg": "./src/img/buy_gmx_bond.svg",
	"./buy_transfer_eth.svg": "./src/img/buy_transfer_eth.svg",
	"./coinbaseWallet.png": "./src/img/coinbaseWallet.png",
	"./coingecko.png": "./src/img/coingecko.png",
	"./cross.svg": "./src/img/cross.svg",
	"./cryptocom.png": "./src/img/cryptocom.png",
	"./cta-button-bg.svg": "./src/img/cta-button-bg.svg",
	"./featured/cut_costs.svg": "./src/img/featured/cut_costs.svg",
	"./featured/effortless.svg": "./src/img/featured/effortless.svg",
	"./featured/mitigate.svg": "./src/img/featured/mitigate.svg",
	"./featured/total_control.svg": "./src/img/featured/total_control.svg",
	"./features/advanced-order-types.png": "./src/img/features/advanced-order-types.png",
	"./features/ai-trading-helper.png": "./src/img/features/ai-trading-helper.png",
	"./features/fully-decentralized.png": "./src/img/features/fully-decentralized.png",
	"./features/mobile-friendly.png": "./src/img/features/mobile-friendly.png",
	"./features/simple-onboarding.png": "./src/img/features/simple-onboarding.png",
	"./flag_en.svg": "./src/img/flag_en.svg",
	"./flag_es.svg": "./src/img/flag_es.svg",
	"./flag_fr.svg": "./src/img/flag_fr.svg",
	"./flag_ja.svg": "./src/img/flag_ja.svg",
	"./flag_ko.svg": "./src/img/flag_ko.svg",
	"./flag_ru.svg": "./src/img/flag_ru.svg",
	"./flag_zh.svg": "./src/img/flag_zh.svg",
	"./footer/footer-large-logo.svg": "./src/img/footer/footer-large-logo.svg",
	"./gmx-logo-with-name.png": "./src/img/gmx-logo-with-name.png",
	"./gmx-logo-with-name.svg": "./src/img/gmx-logo-with-name.svg",
	"./governance.svg": "./src/img/governance.svg",
	"./hero-featured-image.png": "./src/img/hero-featured-image.png",
	"./ic-communityproject.svg": "./src/img/ic-communityproject.svg",
	"./ic_aave_24.svg": "./src/img/ic_aave_24.svg",
	"./ic_aave_30.svg": "./src/img/ic_aave_30.svg",
	"./ic_aave_40.svg": "./src/img/ic_aave_40.svg",
	"./ic_ada_16.svg": "./src/img/ic_ada_16.svg",
	"./ic_ada_24.svg": "./src/img/ic_ada_24.svg",
	"./ic_ada_40.svg": "./src/img/ic_ada_40.svg",
	"./ic_ada_96.svg": "./src/img/ic_ada_96.svg",
	"./ic_aig_24.svg": "./src/img/ic_aig_24.svg",
	"./ic_aig_40.svg": "./src/img/ic_aig_40.svg",
	"./ic_aigisos_16.svg": "./src/img/ic_aigisos_16.svg",
	"./ic_aigisos_24.svg": "./src/img/ic_aigisos_24.svg",
	"./ic_aigisos_96.svg": "./src/img/ic_aigisos_96.svg",
	"./ic_arbitrum_16.svg": "./src/img/ic_arbitrum_16.svg",
	"./ic_arbitrum_24.svg": "./src/img/ic_arbitrum_24.svg",
	"./ic_arbitrum_96.svg": "./src/img/ic_arbitrum_96.svg",
	"./ic_arbitrum_hover_16.svg": "./src/img/ic_arbitrum_hover_16.svg",
	"./ic_arrowleft16.svg": "./src/img/ic_arrowleft16.svg",
	"./ic_arrowright16.svg": "./src/img/ic_arrowright16.svg",
	"./ic_atom_24.svg": "./src/img/ic_atom_24.svg",
	"./ic_atom_40.svg": "./src/img/ic_atom_40.svg",
	"./ic_avalanche_16.svg": "./src/img/ic_avalanche_16.svg",
	"./ic_avalanche_24.svg": "./src/img/ic_avalanche_24.svg",
	"./ic_avalanche_96.svg": "./src/img/ic_avalanche_96.svg",
	"./ic_avax_24.svg": "./src/img/ic_avax_24.svg",
	"./ic_avax_30.svg": "./src/img/ic_avax_30.svg",
	"./ic_avax_40.svg": "./src/img/ic_avax_40.svg",
	"./ic_banxa.svg": "./src/img/ic_banxa.svg",
	"./ic_base_16.svg": "./src/img/ic_base_16.svg",
	"./ic_base_24.svg": "./src/img/ic_base_24.svg",
	"./ic_base_40.svg": "./src/img/ic_base_40.svg",
	"./ic_base_96.svg": "./src/img/ic_base_96.svg",
	"./ic_bch_16.svg": "./src/img/ic_bch_16.svg",
	"./ic_bch_24.svg": "./src/img/ic_bch_24.svg",
	"./ic_bch_40.svg": "./src/img/ic_bch_40.svg",
	"./ic_bch_96.svg": "./src/img/ic_bch_96.svg",
	"./ic_binance.svg": "./src/img/ic_binance.svg",
	"./ic_binance_logo.svg": "./src/img/ic_binance_logo.svg",
	"./ic_bnb_16.svg": "./src/img/ic_bnb_16.svg",
	"./ic_bnb_24.svg": "./src/img/ic_bnb_24.svg",
	"./ic_bnb_40.svg": "./src/img/ic_bnb_40.svg",
	"./ic_bnb_96.svg": "./src/img/ic_bnb_96.svg",
	"./ic_bsc.svg": "./src/img/ic_bsc.svg",
	"./ic_bsc_16.svg": "./src/img/ic_bsc_16.svg",
	"./ic_bsc_24.svg": "./src/img/ic_bsc_24.svg",
	"./ic_bsc_40.svg": "./src/img/ic_bsc_40.svg",
	"./ic_bsc_96.svg": "./src/img/ic_bsc_96.svg",
	"./ic_btc.b_24.svg": "./src/img/ic_btc.b_24.svg",
	"./ic_btc.b_40.svg": "./src/img/ic_btc.b_40.svg",
	"./ic_btc_24.svg": "./src/img/ic_btc_24.svg",
	"./ic_btc_40.svg": "./src/img/ic_btc_40.svg",
	"./ic_bungee.png": "./src/img/ic_bungee.png",
	"./ic_busd_24.svg": "./src/img/ic_busd_24.svg",
	"./ic_buy_glp.svg": "./src/img/ic_buy_glp.svg",
	"./ic_cake_16.svg": "./src/img/ic_cake_16.svg",
	"./ic_cake_24.svg": "./src/img/ic_cake_24.svg",
	"./ic_cake_40.svg": "./src/img/ic_cake_40.svg",
	"./ic_cake_96.svg": "./src/img/ic_cake_96.svg",
	"./ic_cash.png": "./src/img/ic_cash.png",
	"./ic_cash.svg": "./src/img/ic_cash.svg",
	"./ic_checked.svg": "./src/img/ic_checked.svg",
	"./ic_coingecko_16.svg": "./src/img/ic_coingecko_16.svg",
	"./ic_coingecko_hover_16.svg": "./src/img/ic_coingecko_hover_16.svg",
	"./ic_convert_down.png": "./src/img/ic_convert_down.png",
	"./ic_convert_down.svg": "./src/img/ic_convert_down.svg",
	"./ic_copy_16.svg": "./src/img/ic_copy_16.svg",
	"./ic_cost.svg": "./src/img/ic_cost.svg",
	"./ic_dai_24.svg": "./src/img/ic_dai_24.svg",
	"./ic_dai_40.svg": "./src/img/ic_dai_40.svg",
	"./ic_discord.svg": "./src/img/ic_discord.svg",
	"./ic_doge_16.svg": "./src/img/ic_doge_16.svg",
	"./ic_doge_24.svg": "./src/img/ic_doge_24.svg",
	"./ic_doge_40.svg": "./src/img/ic_doge_40.svg",
	"./ic_doge_96.svg": "./src/img/ic_doge_96.svg",
	"./ic_dot_16.svg": "./src/img/ic_dot_16.svg",
	"./ic_dot_24.svg": "./src/img/ic_dot_24.svg",
	"./ic_dot_40.svg": "./src/img/ic_dot_40.svg",
	"./ic_dot_96.svg": "./src/img/ic_dot_96.svg",
	"./ic_eth_24.svg": "./src/img/ic_eth_24.svg",
	"./ic_eth_40.svg": "./src/img/ic_eth_40.svg",
	"./ic_fil_16.svg": "./src/img/ic_fil_16.svg",
	"./ic_fil_24.svg": "./src/img/ic_fil_24.svg",
	"./ic_fil_40.svg": "./src/img/ic_fil_40.svg",
	"./ic_fil_96.svg": "./src/img/ic_fil_96.svg",
	"./ic_frax_24.svg": "./src/img/ic_frax_24.svg",
	"./ic_frax_40.svg": "./src/img/ic_frax_40.svg",
	"./ic_gitbook.svg": "./src/img/ic_gitbook.svg",
	"./ic_github.svg": "./src/img/ic_github.svg",
	"./ic_glp_16.svg": "./src/img/ic_glp_16.svg",
	"./ic_glp_24.svg": "./src/img/ic_glp_24.svg",
	"./ic_glp_30.svg": "./src/img/ic_glp_30.svg",
	"./ic_glp_40.svg": "./src/img/ic_glp_40.svg",
	"./ic_glp_64.svg": "./src/img/ic_glp_64.svg",
	"./ic_glp_96.svg": "./src/img/ic_glp_96.svg",
	"./ic_glp_custom.svg": "./src/img/ic_glp_custom.svg",
	"./ic_gmx.svg": "./src/img/ic_gmx.svg",
	"./ic_gmx_24.svg": "./src/img/ic_gmx_24.svg",
	"./ic_gmx_30.svg": "./src/img/ic_gmx_30.svg",
	"./ic_gmx_40.svg": "./src/img/ic_gmx_40.svg",
	"./ic_gmx_64.svg": "./src/img/ic_gmx_64.svg",
	"./ic_gmx_96.svg": "./src/img/ic_gmx_96.svg",
	"./ic_gmx_arbitrum.svg": "./src/img/ic_gmx_arbitrum.svg",
	"./ic_gmx_avax.svg": "./src/img/ic_gmx_avax.svg",
	"./ic_gmx_big.svg": "./src/img/ic_gmx_big.svg",
	"./ic_gmx_custom.svg": "./src/img/ic_gmx_custom.svg",
	"./ic_gmx_footer.svg": "./src/img/ic_gmx_footer.svg",
	"./ic_hop.svg": "./src/img/ic_hop.svg",
	"./ic_info.svg": "./src/img/ic_info.svg",
	"./ic_inj_16.svg": "./src/img/ic_inj_16.svg",
	"./ic_inj_24.svg": "./src/img/ic_inj_24.svg",
	"./ic_inj_40.svg": "./src/img/ic_inj_40.svg",
	"./ic_inj_96.svg": "./src/img/ic_inj_96.svg",
	"./ic_language24.svg": "./src/img/ic_language24.svg",
	"./ic_link.e_40.svg": "./src/img/ic_link.e_40.svg",
	"./ic_link_24.svg": "./src/img/ic_link_24.svg",
	"./ic_link_40.svg": "./src/img/ic_link_40.svg",
	"./ic_liquidity.svg": "./src/img/ic_liquidity.svg",
	"./ic_ltc_16.svg": "./src/img/ic_ltc_16.svg",
	"./ic_ltc_24.svg": "./src/img/ic_ltc_24.svg",
	"./ic_ltc_40.svg": "./src/img/ic_ltc_40.svg",
	"./ic_ltc_96.svg": "./src/img/ic_ltc_96.svg",
	"./ic_matic_24.svg": "./src/img/ic_matic_24.svg",
	"./ic_matic_40.svg": "./src/img/ic_matic_40.svg",
	"./ic_matic_64.svg": "./src/img/ic_matic_64.svg",
	"./ic_matic_96.svg": "./src/img/ic_matic_96.svg",
	"./ic_medium.svg": "./src/img/ic_medium.svg",
	"./ic_menu_dots.svg": "./src/img/ic_menu_dots.svg",
	"./ic_metamask_16.svg": "./src/img/ic_metamask_16.svg",
	"./ic_metamask_hover_16.svg": "./src/img/ic_metamask_hover_16.svg",
	"./ic_mim_24.svg": "./src/img/ic_mim_24.svg",
	"./ic_mim_40.svg": "./src/img/ic_mim_40.svg",
	"./ic_multiswap.svg": "./src/img/ic_multiswap.svg",
	"./ic_new_link_16.svg": "./src/img/ic_new_link_16.svg",
	"./ic_o3.png": "./src/img/ic_o3.png",
	"./ic_olympus.svg": "./src/img/ic_olympus.svg",
	"./ic_olympus_arbitrum.svg": "./src/img/ic_olympus_arbitrum.svg",
	"./ic_pancake.svg": "./src/img/ic_pancake.svg",
	"./ic_selector_dropdowns.svg": "./src/img/ic_selector_dropdowns.svg",
	"./ic_settings_16.svg": "./src/img/ic_settings_16.svg",
	"./ic_settings_24.svg": "./src/img/ic_settings_24.svg",
	"./ic_sign in_16.svg": "./src/img/ic_sign in_16.svg",
	"./ic_sign_out_16.svg": "./src/img/ic_sign_out_16.svg",
	"./ic_simpleswaps.svg": "./src/img/ic_simpleswaps.svg",
	"./ic_stats.svg": "./src/img/ic_stats.svg",
	"./ic_stats_big.svg": "./src/img/ic_stats_big.svg",
	"./ic_synapse.svg": "./src/img/ic_synapse.svg",
	"./ic_telegram.svg": "./src/img/ic_telegram.svg",
	"./ic_tether_24.svg": "./src/img/ic_tether_24.svg",
	"./ic_tokens.svg": "./src/img/ic_tokens.svg",
	"./ic_totaluser.svg": "./src/img/ic_totaluser.svg",
	"./ic_traderjoe.png": "./src/img/ic_traderjoe.png",
	"./ic_trading.svg": "./src/img/ic_trading.svg",
	"./ic_transfer_avax.svg": "./src/img/ic_transfer_avax.svg",
	"./ic_trx_16.svg": "./src/img/ic_trx_16.svg",
	"./ic_trx_24.svg": "./src/img/ic_trx_24.svg",
	"./ic_trx_40.svg": "./src/img/ic_trx_40.svg",
	"./ic_trx_96.svg": "./src/img/ic_trx_96.svg",
	"./ic_twitter.svg": "./src/img/ic_twitter.svg",
	"./ic_uni_24.svg": "./src/img/ic_uni_24.svg",
	"./ic_uni_40.svg": "./src/img/ic_uni_40.svg",
	"./ic_uni_arbitrum.svg": "./src/img/ic_uni_arbitrum.svg",
	"./ic_usdc.e_24.svg": "./src/img/ic_usdc.e_24.svg",
	"./ic_usdc.e_40.svg": "./src/img/ic_usdc.e_40.svg",
	"./ic_usdc_24.svg": "./src/img/ic_usdc_24.svg",
	"./ic_usdc_40.svg": "./src/img/ic_usdc_40.svg",
	"./ic_usdt_24.svg": "./src/img/ic_usdt_24.svg",
	"./ic_usdt_40.svg": "./src/img/ic_usdt_40.svg",
	"./ic_waig_40.svg": "./src/img/ic_waig_40.svg",
	"./ic_wallet_24.svg": "./src/img/ic_wallet_24.svg",
	"./ic_wavax_24.svg": "./src/img/ic_wavax_24.svg",
	"./ic_wavax_40.svg": "./src/img/ic_wavax_40.svg",
	"./ic_wbnb_16.svg": "./src/img/ic_wbnb_16.svg",
	"./ic_wbnb_24.svg": "./src/img/ic_wbnb_24.svg",
	"./ic_wbnb_40.svg": "./src/img/ic_wbnb_40.svg",
	"./ic_wbnb_96.svg": "./src/img/ic_wbnb_96.svg",
	"./ic_wbtc_24.svg": "./src/img/ic_wbtc_24.svg",
	"./ic_wbtc_40.svg": "./src/img/ic_wbtc_40.svg",
	"./ic_wcro_16.svg": "./src/img/ic_wcro_16.svg",
	"./ic_wcro_225.svg": "./src/img/ic_wcro_225.svg",
	"./ic_wcro_24.svg": "./src/img/ic_wcro_24.svg",
	"./ic_wcro_40.svg": "./src/img/ic_wcro_40.svg",
	"./ic_wcro_96.svg": "./src/img/ic_wcro_96.svg",
	"./ic_weth_24.svg": "./src/img/ic_weth_24.svg",
	"./ic_weth_40.svg": "./src/img/ic_weth_40.svg",
	"./ic_xrp_16.svg": "./src/img/ic_xrp_16.svg",
	"./ic_xrp_24.svg": "./src/img/ic_xrp_24.svg",
	"./ic_xrp_40.svg": "./src/img/ic_xrp_40.svg",
	"./ic_xrp_96.svg": "./src/img/ic_xrp_96.svg",
	"./ic_xvs_16.svg": "./src/img/ic_xvs_16.svg",
	"./ic_xvs_24.svg": "./src/img/ic_xvs_24.svg",
	"./ic_xvs_40.svg": "./src/img/ic_xvs_40.svg",
	"./ic_xvs_96.svg": "./src/img/ic_xvs_96.svg",
	"./image (1).png": "./src/img/image (1).png",
	"./image.png": "./src/img/image.png",
	"./indicator-icon.svg": "./src/img/indicator-icon.svg",
	"./ios-depth-chart.png": "./src/img/ios-depth-chart.png",
	"./lg_arbitrum.svg": "./src/img/lg_arbitrum.svg",
	"./logo_GMX.svg": "./src/img/logo_GMX.svg",
	"./logo_GMX_small.svg": "./src/img/logo_GMX_small.svg",
	"./long.svg": "./src/img/long.svg",
	"./metamask-text.svg": "./src/img/metamask-text.svg",
	"./metamask.png": "./src/img/metamask.png",
	"./microsoft.png": "./src/img/microsoft.png",
	"./mobile.png": "./src/img/mobile.png",
	"./page-not-found.svg": "./src/img/page-not-found.svg",
	"./position-share-bg.png": "./src/img/position-share-bg.png",
	"./seapad2.png": "./src/img/seapad2.png",
	"./short.svg": "./src/img/short.svg",
	"./social/discord.svg": "./src/img/social/discord.svg",
	"./social/github.svg": "./src/img/social/github.svg",
	"./social/medium.svg": "./src/img/social/medium.svg",
	"./social/telegram.svg": "./src/img/social/telegram.svg",
	"./social/x.svg": "./src/img/social/x.svg",
	"./sponsers/brand-1.png": "./src/img/sponsers/brand-1.png",
	"./sponsers/brand-2.png": "./src/img/sponsers/brand-2.png",
	"./sponsers/brand-3.png": "./src/img/sponsers/brand-3.png",
	"./sponsers/brand-4.png": "./src/img/sponsers/brand-4.png",
	"./sponsers/brand-5.png": "./src/img/sponsers/brand-5.png",
	"./sponsers/brand-6.png": "./src/img/sponsers/brand-6.png",
	"./sponsers/brand-7.png": "./src/img/sponsers/brand-7.png",
	"./swap.svg": "./src/img/swap.svg",
	"./trading.png": "./src/img/trading.png",
	"./trading2.png": "./src/img/trading2.png",
	"./wallet-connect-text.svg": "./src/img/wallet-connect-text.svg",
	"./walletconnect-circle-blue.svg": "./src/img/walletconnect-circle-blue.svg",
	"./wallets.png": "./src/img/wallets.png",
	"./wallets2-removebg-preview.png": "./src/img/wallets2-removebg-preview.png",
	"./wave-01.png": "./src/img/wave-01.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/img sync recursive ^\\.\\/.*$";